const errorHandler = (error, vm) => {
  console.log('error!!-----')
  console.log(vm)
  console.log(error)
  // router.push('/500')
}
export default errorHandler
